import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {jqxWindowComponent} from "../../../../assets/jqwidgets-ts/angular_jqxwindow";
import {_UsersService} from "../../../services/users.service";
import {Observable} from "rxjs/Observable";

@Component({
  selector: 'my-profile',
  templateUrl: 'myprofile.component.html',
  styleUrls: ['myprofile.component.css'],
})

export class MyProfileBranch implements OnInit {

  @ViewChild('changePasswordModal') changePasswordModal: jqxWindowComponent;

  private $user: Observable<any>;
  private oldPassword: any;
  private newPassword: any;
  private message: any;
  private errorMessage: any;

  constructor (private titleService: Title, private usersService: _UsersService) {}

  ngOnInit() {
    //Set the page title
    this.titleService.setTitle("WiseRisk | My Profile");
    this.$user = this.usersService.getCurrentUser();
  }

  changePassword() {
    this.changePasswordModal.open();
  }

  cancelPasswordChange() {
    this.changePasswordModal.close();
  }

  submitPasswordChange() {
    this.usersService.changePassword(this.oldPassword, this.newPassword).toPromise().then(()=>{
      this.setMessage("Password changed.");
      this.changePasswordModal.close();
    }, () =>
    {
      this.setError("Unable to change password, make sure your old password is correct and your new password is valid.");
      this.changePasswordModal.close();
    })
  }

  saveChanges(user) {
    this.usersService.updateUser(user).toPromise().then(()=>{
      this.setMessage("Changes saved.");
    }, () =>
    {
      this.setError("Error saving changes.");
    })
  }

  setMessage(message){
    this.message = message;
    setTimeout(()=>{
      this.message = null;
    }, 5000);
  }

  setError(errorMessage){
    this.errorMessage = errorMessage;
    setTimeout(()=>{
      this.errorMessage = null;
    }, 5000);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/myprofile/myprofile.component.ts